const bus = ref<Map<string, any>>(new Map());

export default function useEventsBus() {
  function emit(eventName: string, val: any) {
    bus.value.set(eventName, val);
  }

  return {
    emit,
    bus,
  };
}
